var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_558_1061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.53333 7.58333H2.25V7.41667H6.53333H7.74044L6.88689 6.56311L6.30711 5.98333L6.41667 5.87377L8.04289 7.5L6.41667 9.12623L6.30711 9.01667L6.88689 8.43689L7.74044 7.58333H6.53333ZM11.0833 12.0833H11.5222C11.4046 12.1869 11.2507 12.25 11.0833 12.25H7.5V12.0833H11.0833ZM11.75 11.5833C11.75 11.7507 11.6869 11.9046 11.5833 12.0222V11.5833V3.41667V2.9778C11.6869 3.09544 11.75 3.24931 11.75 3.41667V11.5833ZM11.5222 2.91667H11.0833H7.5V2.75H11.0833C11.2507 2.75 11.4046 2.81313 11.5222 2.91667Z",
    fill: "#2E373E",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_558_1061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 10.5,
    fill: "white",
    transform: "translate(1.75 2.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.8deca7faee69273b8b34e40f0cf09897.svg";
export { ForwardRef as ReactComponent };